import SupportIcon from '@clearkit/icons/glyphs/Support';

import StatusIcon from '~/components/audiences/StatusIcon';
import Tooltip from '~/components/RedesignedTooltip';
import { audienceHealth, audienceStatuses } from '~/lib/audiences';

import HealthIndicator from './base';

export default function AudiencesHealthIndicator({
  audience,
  className,
  variant,
}) {
  const health = audienceHealth(audience.externalEstimatedSize);
  let indicator;

  if (audience.status === audienceStatuses.initializing) {
    indicator = <StatusIcon audience={audience} className={className} />;
  } else if (audience.status === audienceStatuses.inactive) {
    indicator = <StatusIcon audience={audience} className={className} />;
  } else if (health === null) {
    indicator = <SupportIcon className="text-gray-400" />;
  } else {
    indicator = (
      <HealthIndicator
        className={className}
        health={health}
        variant={variant}
      />
    );
  }

  return (
    <Tooltip
      title={<AudienceHealthTooltip audience={audience} />}
      placement="top">
      <div className="flex justify-center">{indicator}</div>
    </Tooltip>
  );
}

const AudienceHealthTooltip = ({
  audience: { externalEstimatedSize, status },
}) => {
  const health = audienceHealth(externalEstimatedSize);

  if (status === audienceStatuses.initializing)
    return <>Audience is initializing</>;
  if (status === audienceStatuses.inactive) return <>Audience is inactive</>;
  if (health === null)
    return <>We don't currently support metrics for this audience type</>;
  if (externalEstimatedSize === 0) return <>No matches</>;
  if (externalEstimatedSize <= 2_000)
    return (
      <>
        Tiny audience size <br /> 0K-2K
      </>
    );
  if (externalEstimatedSize <= 10_000)
    return (
      <>
        Small audience size <br /> 2K-10K
      </>
    );
  if (externalEstimatedSize <= 20_000)
    return (
      <>
        Medium audience size <br /> 10K-20K
      </>
    );
  if (externalEstimatedSize <= 200_000)
    return (
      <>
        Normal audience size <br /> 20k-200K
      </>
    );
  if (externalEstimatedSize > 200_000)
    return (
      <>
        Extra-large audience size <br /> 200K+
      </>
    );

  return null;
};

AudiencesHealthIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
  audience: PropTypes.object.isRequired,
};
